/**
 * Link direto para a loja de aplicativos (ClickUp 17ttyenaxrn), usado em LP, e-mail e campanha:
 *
 *   https://app.segfy.com/meu-plano/loja
 *   https://app.segfy.com/meu-plano/loja?modulo=segfy_mensagem&utm_source=lp&utm_campaign=...
 *
 * É CONTRATO PÚBLICO: material impresso e e-mail já disparado não se corrigem — não renomear a
 * rota nem os parâmetros. `modulo` é a chave do módulo no Intranet2 (sem diferença de caixa).
 *
 * A loja mora no react-gestao, dentro de dois iframes (casca → página legada → embed); cada
 * camada repassa só estes parâmetros. O retorno depois do login já preserva a rota inteira
 * (utils/returnUrl), então eles também sobrevivem ao SSO.
 */
export const PARAMETROS_DA_LOJA = ['aba', 'modulo', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

export const ROTA_PUBLICA_DA_LOJA = '/meu-plano/loja'

/**
 * Rota pública → tela do Meu Plano na aba da loja, com o módulo e os utm intactos. Só os
 * parâmetros da loja passam: o link é público e não pode carregar `return_url` e afins para a casca.
 */
export function destinoDaLoja (query) {
    const daLoja = {}
    PARAMETROS_DA_LOJA.forEach(nome => {
        if (query && query[nome] !== undefined) daLoja[nome] = query[nome]
    })
    return { path: '/financeiro/meusPagamentos', query: { ...daLoja, aba: 'loja' } }
}

/**
 * Query que segue para o iframe da loja: só os parâmetros dela (o `redirect=true` do login e
 * afins ficam na casca). Parâmetro repetido (?modulo=a&modulo=b) chega como array — ignorado.
 */
export function queryParaOIframe (query) {
    const params = new URLSearchParams()
    PARAMETROS_DA_LOJA.forEach(nome => {
        const valor = query && query[nome]
        if (typeof valor === 'string' && valor !== '') params.set(nome, valor)
    })
    const texto = params.toString()
    return texto ? '?' + texto : ''
}
